"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getKinds = exports.createRowLookup = void 0;
const types_1 = require("../types");
function createRowLookup(columns, filteredRows, virtuosoRef) {
    return {
        scrollTo(kind, id) {
            if (virtuosoRef.current === null) {
                // In theory we could support as=div and as=table by finding the DOM
                // element and calling .scrollIntoView, just not doing that yet.
                throw new Error("scrollTo is only supported for as=virtual");
            }
            const index = filteredRows.findIndex(([r]) => r && r.kind === kind && r.id === id);
            virtuosoRef.current.scrollToIndex({ index, behavior: "smooth" });
        },
        currentList() {
            return filteredRows.map((r) => r[0]);
        },
        lookup(row, additionalFilter = () => true) {
            var _a, _b;
            var _c;
            const rows = filteredRows.map((r) => r[0]).filter(additionalFilter);
            // Ensure we have `result.kind = {}` for each kind
            const result = Object.fromEntries(getKinds(columns).map((kind) => [kind, {}]));
            // This is an admittedly cute/fancy scan, instead of just `rows.findIndex`, but
            // we do it this way so that we can do kind-aware prev/next detection.
            let key = "prev";
            for (let i = 0; i < rows.length; i++) {
                const each = rows[i];
                // Flip from prev to next when we find it
                if (each.kind === row.kind && each.id === row.id) {
                    key = "next";
                }
                else {
                    if (key === "prev") {
                        // prev always overwrites what was there before
                        result[key] = each;
                        result[each.kind][key] = each;
                    }
                    else {
                        // next only writes first seen
                        (_a = result[key]) !== null && _a !== void 0 ? _a : (result[key] = each);
                        (_b = (_c = result[each.kind])[key]) !== null && _b !== void 0 ? _b : (_c[key] = each);
                    }
                }
            }
            return result;
        },
    };
}
exports.createRowLookup = createRowLookup;
function getKinds(columns) {
    return Object.keys(columns.find((c) => !c.isAction) || {}).filter((key) => !types_1.nonKindGridColumnKeys.includes(key));
}
exports.getKinds = getKinds;
